import { CustomFieldComponentProps } from '../CustomFieldComponent'
import PageCheckBox from '../../DonationForm/components/atoms/PageCheckBox'
import { ExtraFieldComponent } from '../../ExtraFields'
import { ReactNode } from 'react'

const MARKDOWN_LINK_REGEX = /\[([^\]]+)\]\(([^)]+)\)/g

const parseMarkdownLinks = (text: string): ReactNode[] => {
  const parts: ReactNode[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null

  while ((match = MARKDOWN_LINK_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index))
    }
    parts.push(
      <a
        key={match.index}
        href={match[2]}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        style={{ textDecoration: 'underline', pointerEvents: 'auto' }}
      >
        {match[1]}
      </a>,
    )
    lastIndex = match.index + match[0].length
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return parts
}

const renderLabel = (label: string | ReactNode): ReactNode => {
  if (typeof label === 'string') {
    return <>{parseMarkdownLinks(label)}</>
  }
  return label
}

const CustomCheckbox = ({
  id,
  name,
  label,
  onChange,
  value,
  defaultValue,
  conditionalFields,
  isRequired,
  CustomFieldComponent,
}: CustomFieldComponentProps) => {
  const isChecked = value ? value === 'true' : defaultValue === 'true'
  return (
    <>
      <PageCheckBox
        id={`custom-field-${name}`}
        name={name}
        label={
          <>
            {renderLabel(label)}
            {isRequired && <span style={{ color: 'red' }}> *</span>}
          </>
        }
        required={isRequired}
        onChange={(e) => {
          onChange?.({
            target: {
              name: id,
              value: `${e}`,
            },
          } as React.ChangeEvent<HTMLInputElement>)
        }}
        isChecked={isChecked}
      />
      {isChecked &&
        conditionalFields &&
        CustomFieldComponent &&
        conditionalFields.map((field) => <ExtraFieldComponent {...field} key={field.customField?.id ?? field.label} />)}
    </>
  )
}

export default CustomCheckbox
